<template>
<div class="body_flow page">
    <div v-if="initilizingCart" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <div v-if="cartError" class="error_popup popup-desktop" style="display:block;">
        <div class="error_box error-pop-desk">
            <div class="text-block-1101">Cart Error</div>
            <div class="text-block-1102">{{ message }}</div>
        </div>
    </div>

    <div v-if="submitted" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    <!-- Payment Error Toast -->
    <div v-if="paymentError" class="error-popup">
        <span>{{ errorMessage }}</span>
        <button class="error-popup-close" @click="paymentError = false">&times;</button>
    </div>

    <section class="section-fixed-prognav">
        <div class="flow-nav-wrap">
            <div class="checkout-flow-nav-div">
                <div class="div-block-2252">
                    <div class="text-block-1727">Call us</div>
                    <a :href="supportPhoneTel" class="link-90">+1 {{ supportPhone }}</a>
                </div>
                <a href="#" class="link-block-33 w-inline-block"><img sizes="100vw" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="NewSelf" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-378 logo-nav"></a>
                <div class="div-block-2253" v-if="active_el>3">
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="Go back" class="image-651" style="margin-bottom: 3px;"></a>
                </div>
                <div class="mobile-nav-links">
                    <a :href="supportPhoneTel" class="link-block-109 w-inline-block"><img src="@/assets/images/icon_call_1.svg" loading="lazy" alt="Call us" class="image-692"></a>
                    <a href="#" class="button-175 active w-button" @click.prevent="GoBack()"  v-if="active_el>3"><img src="@/assets/images/icon_arrowback.svg" loading="lazy" alt="Go back" class="image-651"></a>
                </div>
            </div>
        </div>
        <div class="checkout-flow-prog-div">
            <div class="quiz-progress-div">
                <div class="progress" :style="{ width: Math.round((active_el / (totalSteps+1)) * 100) + '%' }"></div>
            </div>
        </div>
    </section>
    <section class="section-fixed-controlnav hide-block">
        <div class="flow-ctrl-nav-wrap">
            <div class="ctrl-div">
                <div class="ctrl-div-flex">
                    <a href="#" class="continue-button w-button">Continue</a>
                </div>
            </div>
        </div>
    </section>
    <section class="section_checkout-flow">
        <div class="flow_wrap">

            
            <div class="step5_div" v-if="active_el === 11">
                <!-- Loading Overlay -->
                <div v-if="submitted" class="loading-overlay2">
                    <div class="">
                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                            </circle>
                        </svg>
                    </div>
                </div>

                <div class="flow-step1-headers">
                    <div class="checkout-flow-headers">Complete your order</div>
                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="Call us" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>

                <div class="flow_step5-choiceflex-div" >
                    <!-- Payment Plan Selection -->
                    <div class="flow-payplan-div">
                        <div class="checkout-form w-form">
                            <form id="email-form" name="email-form" data-name="Email Form" method="get">
                                <div class="flow_payplan_select">

                                    <!-- Selected Medication Display -->
                                    <div class="order-item-flex">
                                        <div class="div-block-2241">
                                            <div class="product-box-flex">
                                                <div class="product-name-and-sub">
                                                    <div class="text-block-1690">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}<span class="text-span-422">+</span></div>
                                                    <div class="text-block-1691">COMPOUNDED W/ {{ selectedMedication === 'semaglutide' ? 'B12' : 'B6' }}</div>
                                                </div>
                                                <div v-if="nextThreeMonthDoses" class="checkout-dosage-div">
                                                    <div class="checkout---month-dose" v-for="monthDose in nextThreeMonthDoses" :key="monthDose.month">
                                                        <div class="text-block-1715">MONTH {{ monthDose.month }}</div>
                                                        <div class="text-block-1717">{{ monthDose.dose }} <span class="text-span-421">MG</span></div>
                                                        <div class="text-block-1715">Weekly Dose</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-block-1693">All Dosages are same price. Meet w/ provider to personalize plan.</div>
                                        </div>
                                        <div class="order_img_div">
                                            <img :src="selectedMedication === 'semaglutide' ? '/images/Semaglutide-Vial_1.webp' : '/images/Tirzepatide-Vial_1.webp'" />

                                        </div>
                                    </div>
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===0}" @click="changePaymentTerms(0)">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===0}"></div>
                                        <input type="radio" v-model="paymentInfo.payment_terms" :value="0" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                        <span class="checkout-checkbox-text w-form-label">
                                            <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getTotalPrice(0)) }}</strong><span class="text-span-416"><strong><sup>{{ (getTotalPrice(0) % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                            <span class="text-span-417"> 1 Month Supply.</span><br>
                                        </span>
                                        <div class="div-block-2242">
                                            <div class="text-block-1694">One Time Purchase</div>
                                        </div>
                                    </label>

                                    <div class="text-block-1697">Sign up for other options and save.</div>

                                    <!-- Payment Plan Options -->
                                    <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===1}" @click="changePaymentTerms(1)">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===1}"></div>
                                        <input type="radio" v-model="paymentInfo.payment_terms" :value="1" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                        <span class="checkout-checkbox-text w-form-label">
                                            <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getFirstMonthPrice()) }}</strong><span class="text-span-416"><strong><sup>{{ (getFirstMonthPrice() % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                            <span class="text-span-417">/mo <br> <span class="tosspan">*3 month supply paid monthly. No credit checks or financing charges.</span></span>
                                        </span>
                                        <div class="div-block-2242">
                                            <div class="text-block-1694">Recurring</div>
                                        </div>
                                    </label>

                                    <div class="text-block-1697">Stay committed longer, save more.</div>
                                    <div class="plans-div">
                                        <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===3}" @click="changePaymentTerms(3)">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===3}"></div>
                                            <input type="radio" v-model="paymentInfo.payment_terms" :value="3" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text w-form-label">
                                                <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getTotalPrice(3) / 3) }}</strong><span class="text-span-416"><strong><sup>{{ ((getTotalPrice(3) / 3) % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                                <span class="text-span-417">/ mo. (3 mo plan)</span><br>
                                            </span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatPriceWithCommas(getTotalPrice(3)) }}</span> today</div>
                                            </div>
                                        </label>

                                        <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===6}" @click="changePaymentTerms(6)">
                                            <span class="plan-badge plan-badge--popular">Popular</span>
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===6}"></div>
                                            <input type="radio" v-model="paymentInfo.payment_terms" :value="6" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text w-form-label">
                                                <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getTotalPrice(6) / 6) }}</strong><span class="text-span-416"><strong><sup>{{ ((getTotalPrice(6) / 6) % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                                <span class="text-span-417">/ mo. (6 mo plan)</span><br>
                                            </span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatPriceWithCommas(getTotalPrice(6)) }}</span> today</div>
                                            </div>
                                        </label>

                                        <label class="w-checkbox checkout_checkbox-field w-clearfix" :class="{'checkout_checkbox-selected' : paymentInfo.payment_terms===12}" @click="changePaymentTerms(12)">
                                            <span class="plan-badge plan-badge--recommended">Recommended</span>
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{'w--redirected-checked' : paymentInfo.payment_terms===12}"></div>
                                            <input type="radio" v-model="paymentInfo.payment_terms" :value="12" name="payment-plan" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text w-form-label">
                                                <span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(getTotalPrice(12) / 12) }}</strong><span class="text-span-416"><strong><sup>{{ ((getTotalPrice(12) / 12) % 1).toFixed(2).split('.')[1] }}</sup></strong></span></span>
                                                <span class="text-span-417">/ mo. (12 mo plan)</span><br>
                                            </span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatPriceWithCommas(getTotalPrice(12)) }}</span> today</div>
                                                <SummerSaleBadge />
                                            </div>
                                        </label>

                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="flow-ctrls-div" style="justify-content: center;">
                            <a href="#" class="continue-button step w-button" style="width: 100%;" @click.prevent="continueFromStep17">Continue <span class="text-span-423">-&gt;</span></a>
                        </div>
                    </div>
                    

                   
                    <div class="flow-pay-summary hide-in-mobile">
                        <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="17a32de0-f4b2-ba0e-e661-91591044c4c7" aria-label="Email Form">
                            <div class="flow-sum-maindiv">
                            <div class="flow-summary-top">
                                <h2 class="text-block-1688-copy">Order Summary</h2>
                            </div>
                            <div class="flow-sum-orders-div">
                                <div class="order-line-div">
                                <div class="order-name">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                <div class="div-block-2243">
                                    <div class="order-price"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalOrderAmount()) }}<sup class="superscript-9">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                </div>
                                </div>
                            </div>
                            <div class="order-total-div">
                                <div class="text-block-1698">Due today</div>
                                <div class="div-block-2243">
                                <div class="order-price-total"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalOrderAmount()) }}<sup class="superscript-9-copy">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                </div>
                            </div>
                            <div class="flow-sum-guarantee-div">
                                <p class="paragraph-217"><strong>Our guarantee:</strong> If you pay for a treatment and your provider determines you're not eligible, we'll issue a full refund</p>
                            </div>
                            </div>
                        </form>
                        <div class="w-form-done" tabindex="-1" role="region" aria-label="Email Form success">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail" tabindex="-1" role="region" aria-label="Email Form failure">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="step6_div" v-if="active_el === 12">
                <div class="flow-step2-headers">
                    <h1 class="checkout-flow-headers">Payment details</h1>

                    <div class="div-block-2240 hide-flex">
                        <div class="text-block-1687">Not sure?</div>
                        <a href="#" class="link-block-47 hide w-inline-block"><img loading="lazy" src="@/assets/images/icon_call.svg" alt="Call us" class="image-379">
                            <div class="text-block-711">Talk with a Care Concierge</div>
                        </a>
                    </div>
                </div>
                <div class="flow_step3-form-div">
                    <div class="checkout-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692faed9501e8f516d03b70a" data-wf-element-id="5e212543-757c-9c76-d0d5-ebcebbfcc5e5">
                            <div class="flow-payment-div" :class="{'dropdown-expanded': summeryOpen}">
                                <div data-hover="false" data-delay="0" class="flow-dropdown-sum w-dropdown" :class="{'w--open' : summeryOpen}" @click.prevent="summeryOpen = !summeryOpen">
                                    <div class="flow-sum-droptoggle w-dropdown-toggle" :class="{'w--open' : summeryOpen}" @click.prevent="summeryOpen = !summeryOpen">
                                        <div class="icon-49 w-icon-dropdown-toggle"></div>
                                        <div class="drop-sum-label-div div-block-2244">
                                            <div class="text-block-1701">Due Today </div>
                                            <div class="text-block-1701"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(displayTotal) }}<span class="text-span-418"><sup>{{ (displayTotal % 1).toFixed(2).split('.')[1] }}</sup></span></span></div>
                                        </div>
                                    </div>
                                    <div class="dropdown-list-18 w-dropdown-list" :class="{'w--open' : summeryOpen}">
                                        <div class="flow-sum-maindiv">
                                            <div class="flow-summary-top">
                                                <h2 class="text-block-1688-copy">Order Summary</h2>
                                            </div>
                                            <div class="flow-sum-orders-div">
                                                <div class="order-line-div">
                                                    <div class="order-name">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                                    <div class="div-block-2243">
                                                        <div class="order-price"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(getTotalOrderAmount()) }}<sup class="superscript-9">{{ (getTotalOrderAmount() % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="order-total-div">
                                                <div class="text-block-1698">Due today</div>
                                                <div class="div-block-2243">
                                                    <div class="order-price-total"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(displayTotal) }}<sup class="superscript-9-copy">{{ (displayTotal % 1).toFixed(2).split('.')[1] }}</sup></span> </div>
                                                </div>
                                            </div>
                                            <div class="text-block-1705">What&#x27;s included</div>
                                            <div class="inclusions-new">
                                                <div class="flow_inclusions-div">
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img :src="selectedMedication === 'semaglutide' ? '/images/Semaglutide-Vial_1.webp' : '/images/Tirzepatide-Vial_1.webp'" loading="lazy" :alt="selectedMedication === 'semaglutide' ? 'Semaglutide vial' : 'Tirzepatide vial'" class="image-681"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">{{ selectedMedication === 'semaglutide' ? 'Semaglutide' : 'Tirzepatide' }}</div>
                                                                <p class="inclusions-subs" v-if="paymentInfo.payment_terms===12">3 Vials Every 90 Days for a Year.</p>
                                                                <p class="inclusions-subs" v-else-if="paymentInfo.payment_terms===6">3 month supply now, 3 more in 90 days.</p>
                                                                <p class="inclusions-subs" v-else-if="paymentInfo.payment_terms===3">3 month supply.</p>
                                                                <p class="inclusions-subs" v-else-if="paymentInfo.payment_terms===0">1 Month Supply</p>
                                                                <p class="inclusions-subs" v-else>3 Month Supply Paid Monthly</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img src="@/assets/images/icon_stetoscope.webp" loading="lazy" alt="Physician consultation" class="image-681"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">Doctor Support &amp; Monitoring</div>
                                                                <p class="inclusions-subs">Consult with Board-certified experts</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                    <div class="flow-inclusion-entry-div">
                                                        <div class="inclusions-left-div">
                                                            <div class="inclusion-img-div"><img src="@/assets/images/icon_van.webp" loading="lazy" alt="Free shipping" class="image-683"></div>
                                                            <div class="inclusions-text-div">
                                                                <div class="text-block-1706">Express Shipping</div>
                                                                <p class="inclusions-subs">We ship all medications next-day on cold packs.</p>
                                                            </div>
                                                        </div>
                                                        <div class="inclusions-right-div">
                                                            <div class="text-block-1708">Included</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="div-block-2248">
                                                    <div class="text-block-1712">Total</div>
                                                    <div class="div-block-2249">
                                                        <div class="text-block-1711"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(displayTotal) }}<span><sup class="superscript-11">{{ (displayTotal % 1).toFixed(2).split('.')[1] }}</sup></span></span></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flow-sum-guarantee-div">
                                                <p class="paragraph-217"><strong>Our guarantee:</strong> If you pay for a treatment and your provider determines you&#x27;re not eligible, we&#x27;ll issue a full refund</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Price breakdown. Visible without expanding the Due Today
                                     dropdown so the sub-price is never a surprise. Subtotal is
                                     gross and the Discount row is the exact difference, so the
                                     rows always sum to Total. -->
                                <div class="ft-sum-breakdown">
                                    <div class="ft-sum-row">
                                        <span class="ft-sum-label">Shipping</span>
                                        <span class="ft-sum-value">FREE</span>
                                    </div>
                                    <div class="ft-sum-row">
                                        <span class="ft-sum-label">Subtotal</span>
                                        <span class="ft-sum-value" :class="{ 'price-loading': !pricesReady }">${{ formatPriceWithCommas(getCurrentPrice()) }}</span>
                                    </div>
                                    <div class="ft-sum-row" v-if="summaryDiscount > 0">
                                        <span class="ft-sum-label">Discount</span>
                                        <span class="ft-sum-value">-${{ formatPriceWithCommas(summaryDiscount) }}</span>
                                    </div>
                                    <div class="ft-sum-row ft-sum-total">
                                        <span class="ft-sum-label">Total</span>
                                        <span class="ft-sum-value" :class="{ 'price-loading': !pricesReady }">${{ formatPriceWithCommas(displayTotal) }}</span>
                                    </div>
                                </div>

                                <div class="form-field-label">Coupon Code</div>
                                <div class="div-block-2246">
                                    <input class="text-field-68 w-input" maxlength="256" :class="{'field-error' : couponError}" name="field" data-name="Field" v-model="paymentInfo.couponCode" placeholder="Optional Coupon Code" type="text" id="field" :disabled="couponApplied">
                                    <a href="#" @click.prevent="handleCouponSubmit" class="button-172 w-button" :class="{'disabled': couponApplied}">{{ couponApplied ? 'Applied' : 'Apply' }}</a>
                                </div>

                                <h2 class="text-block-1704">Payment Method</h2>

                                <!-- Express Checkout (Apple Pay / Google Pay / Klarna) -->
                                <div class="express-checkout-section">
                                    <div class="express-checkout-box" :class="{ 'single-option': !canMakeExpressCheckout }">
                                        <express-checkout-button
                                            :amount="walletSheetAmountInCents"
                                            @token="handleExpressPayment"
                                            @can-make-payment="canMakeExpressCheckout = $event"
                                        />
                                        <button v-if="paymentInfo.payment_terms !== 1" type="button" class="klarna-btn" :disabled="submitted" @click="payWithKlarna">
                                            <span class="klarna-btn-text">Buy now, pay later with</span>
                                            <img class="klarna-logo" src="@/assets/images/Klarna.png" alt="Klarna" />
                                        </button>
                                    </div>
                                    <div class="pe-divider">
                                        <div class="pe-divider-line"></div>
                                        <span>OR</span>
                                        <div class="pe-divider-line"></div>
                                    </div>
                                </div>

                                
                                <stripe-payment-element
                                    ref="stripePayment"
                                    :base-url="baseUrl"
                                    :user-id="user?.id"
                                    :user-name="userName"
                                    :user-email="user?.email"
                                    :hide-address-fields="true"
                                    :billing-address="customerInfo"
                                    @ready="hasCardInput = $event"
                                    @error="handlePaymentError"
                                    @token="handlePaymentToken"
                                />

                                <div class="address-section">
                                    <label class="pe-label-7x" style="margin-top: 20px; display: block;">Shipping Address</label>
                                    <div :class="{ 'address-highlight': addressBlink }">
                                        <google-places-autocomplete-new :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                                    </div>
                                </div>

                                <!-- Payment Error Display -->
                                <div v-if="paymentError" class="w-form-fail" style="display:block; margin-top: 15px; margin-bottom: 15px;">
                                    <div>{{ errorMessage }}</div>
                                </div>

                                <div class="div-block-2247">
                                    <button type="button" @click.prevent="getStripeToken" :disabled="submitted" class="pay-button w-button">
                                        {{ submitted ? 'Processing...' : 'Pay' }}
                                    </button>
                                    <p class="paragraph-185-copy">
                                        By clicking "Pay Now" you agree to enroll in a {{ paymentInfo.payment_terms }}-month program{{ paymentInfo.payment_terms > 1 ? ' billed upfront' : ' billed monthly' }}, with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the
                                        <a href="https://newself.com/returns-and-refund" target="_blank">Refund Policy</a>,
                                        <a href="https://newself.com/terms-of-use" target="_blank">Terms and Conditions</a>,
                                        <a href="https://newself.com/terms-of-use" target="_blank">Terms of Use</a>,
                                        <a href="https://newself.com/privacy-policy" target="_blank">Privacy Policy</a>,
                                        <a href="https://newself.com/hipaa" target="_blank">HIPAA Notice</a>, and
                                        <a href="https://newself.com/telehealth-consent" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                                    </p>
                                </div>
                            </div>
                        </form>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Priority Physician Review — offered once the order is captured, never before -->
    <fast-track-upsell-modal
        v-if="fastTrackOffer"
        :addon="fastTrackAddon"
        :payment-method="fastTrackOffer.paymentMethod"
        :context="fastTrackOffer"
        @shown="onFastTrackShown"
        @purchased="onFastTrackPurchased"
        @done="onFastTrackDone"
    />
</div>
</template>

<script>
// ===== COMMENTED OUT: Basis Theory (keeping for revert) =====
// import {
//     BasisTheory
// } from "@basis-theory/basis-theory-js";
// const bt = await new BasisTheory().init(process.env.VUE_APP_BASIS, {
//     elements: true
// });
// ===== END COMMENTED OUT =====

import { loadStripe } from "@stripe/stripe-js"
let stripe = null;
import GooglePlacesAutocompleteNew from '../common/GooglePlacesAutocomplete_new.vue'
import StripePaymentElement from '../common/StripePaymentElement.vue'
import ExpressCheckoutButton from '../common/ExpressCheckoutButton.vue'
import fastTrackUpsell from '@/mixins/fastTrackUpsell.js'
import { stashKlarnaPurchase } from '@/utils/klarnaPurchaseTracking.js'
import {
    mapActions,
    mapGetters
} from 'vuex'

export default {
    name: 'WeightLossCheckoutFlow',
    mixins: [fastTrackUpsell],
    fastTrackFunnelStep: 18,
    fastTrackForm: "pre_qualify_v2",
    components: {
        GooglePlacesAutocompleteNew,
        StripePaymentElement,
        ExpressCheckoutButton
    },
    props: ['baseUrl', 'googleMapsApiKey'],
    data() {
        return {
            active_el: 11,
            totalSteps: 12,
            errorMessage: '',
            summeryOpen: false,
            // ===== COMMENTED OUT: Basis Theory =====
            // cardElement: null,
            // ===== END COMMENTED OUT =====

            hasCardInput: false,
            addressBlink: false,
            canMakeExpressCheckout: false,
            submitted: false,
            correlationId: null,
            paymentError: false,
            selectedMedication: '',
            paymentAttempts: 0,
            maxPaymentAttempts: 3,
            couponError: false,
            couponValid: false,
            couponApplied: false,
            initilizingCart: true,
            cartError: false,
            message: '',

            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            paymentInfo: {
                payment_terms: 12, // default to the Recommended (12-month) plan
                user_id: '',
                cardToken: '',
                cardBrand: '',
                amount: 0,
                discount: 0,
                medication: '',
                couponCode: '',
                couponId: null,
                paymentMethod: null,
                cartItems: [],
                cardDetails: [],
                planId: '',
                // Card info from Stripe
                cardBin: '',
                cardLast4: '',
            },
            pricingConfig: JSON.parse(process.env.VUE_APP_PRICING || '{"semaglutide":{"monthly":{"first":194.97,"regular":194.97},"terms":{"3":449.91,"6":749.82,"12":1199.64, "0": 209.97}},"tirzepatide":{"monthly":{"first":274.97,"regular":274.97},"terms":{"3":644.91,"6":1169.82,"12":2099.64, "0": 274.97, "2": 259.97}}}'),
            // Live plans from /api/get-all-plans keyed by payment_terms: { id, price }.
            // Empty until loadPlans resolves; on fetch failure it stays empty so pricing
            // falls back to pricingConfig and planId falls back to paymentInfo.planId.
            apiPlans: {},
            // Gates the price display until the live plan fetch settles, so the env
            // fallback price never flashes on screen before the real one loads.
            pricesReady: false,
        }
    },
    async mounted() {
        await this.checkAuthAndInitialize();

        // Load live plan prices + plan ids for the cart's product (no-op if empty)
        await this.loadPlans();
        // Reveal prices once the live fetch settled so the env fallback never flashes.
        this.pricesReady = true;

        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }

        // ===== COMMENTED OUT: Basis Theory init (was at module level) =====
        // bt = await new BasisTheory().init(process.env.VUE_APP_BASIS, { elements: true });
        // ===== END COMMENTED OUT =====
        await this.initStripe();
        this.prefillFromUserData();

        window.addEventListener('pageshow', this.handlePageShow);
    },
    beforeDestroy() {
        window.removeEventListener('pageshow', this.handlePageShow);
    },
    computed: {
        ...mapGetters(['user', 'isAuthenticated', 'cartItems', 'cartTotal', 'cartTotalNoDiscount']),

        isLoggedin() {
            return this.isAuthenticated;
        },

        userName() {
            if (this.user?.first_name || this.user?.last_name) {
                return `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim();
            }
            return '';
        },

        amountInCents() {
            return Math.round(this.getTotalOrderAmount() * 100);
        },

        // What the Apple/Google Pay sheet shows. Display only: the express element is
        // created with paymentMethodCreation:'manual', so it tokenizes and never charges.
        // amountInCents is already net of any coupon here (getTotalOrderAmount subtracts it).
        walletSheetAmountInCents() {
            return this.amountInCents;
        },
        // What the customer sees as their total.
        displayTotal() {
            return this.getTotalOrderAmount();
        },
        // Discount actually applied, taken as the difference rather than from
        // paymentInfo.discount — getTotalOrderAmount clamps at 0, so a coupon larger
        // than the plan price would otherwise make the summary rows disagree.
        summaryDiscount() {
            return parseFloat((this.getCurrentPrice() - this.getTotalOrderAmount()).toFixed(2));
        },

        selectedPlanId() {
            // Plan ObjectId for the selected term (backend charges the plan price off this)
            const plan = this.apiPlans[this.paymentInfo.payment_terms];
            return plan ? plan.id : this.paymentInfo.planId;
        },

        getProductPricingData() {
            return this.selectedMedication === 'semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;
        },

        nextThreeMonthDoses() {
            if (!this.selectedMedication) {
                return null;
            }

            // Define titration schedules for each medication
            const semaglutideDoses = ['0.25 mg', '0.5 mg', '1.0 mg', '2.0 mg', '2.5 mg'];
            const tirzepatideDoses = ['2.5 mg', '5.0 mg', '7.5 mg', '10.0 mg', '12.5 mg', '15.0 mg'];

            let currentMedication = this.selectedMedication;
            let doses = currentMedication === 'semaglutide' ? semaglutideDoses : tirzepatideDoses;

            const result = [];

            // Show first 3 months starting from lowest dose
            for (let i = 0; i < 3; i++) {
                const monthNumber = i + 1;
                const doseValue = doses[Math.min(i, doses.length - 1)];
                const numericDose = parseFloat(doseValue);

                result.push({
                    month: monthNumber,
                    dose: numericDose,
                    isHighest: i === doses.length - 1
                });
            }

            return result;
        }
    },
    methods: {
        ...mapActions(['setCartVisibility', 'addToCart']),

        async handlePageShow(event) {
            if (event.persisted) {
                this.submitted = false;
                if (this.$refs.stripePayment) {
                    this.$refs.stripePayment.resetElement();
                }
            }
        },

        checkAuthAndInitialize() {
            if (!this.isLoggedin) {
                this.$axios.get(`${this.baseUrl}/api/get-cart/${this.$route.params.cart_id}`, {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    }).then(response => {
                        if (response.data.status === 'success') {
                            let cartItem = response.data.cartItem;
                            try {
                                let keyToDelete = "sema_offer";
                                if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                    this.$store.dispatch('addSemaOffer', cartItem[keyToDelete]);
                                    delete cartItem[keyToDelete];
                                }
                                keyToDelete = "tir_offer";
                                if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                                    this.$store.dispatch('addTirOffer', cartItem[keyToDelete]);
                                    delete cartItem[keyToDelete];
                                }
                            } catch (error) {
                                console.log(error.message)
                            }

                            this.$store.dispatch("doLogin", response.data.userData);
                            this.$store.dispatch('addToCart', cartItem);
                            this.setCartVisibility(false);
                            window.location.reload();

                        } else {
                            this.initilizingCart = false;
                            this.message = response.data.message;
                            this.cartError = true;
                            console.error("Unexpected response:", response.data);
                        }
                    })
                    .catch(error => {
                        console.error("Error saving cart:", error);
                        this.initilizingCart = false;
                        this.message = `${error.message}. Please check the checkout link is correct.`
                        this.cartError = true;
                    });
            } else {
                this.initilizingCart = false;

                // If user is logged in and has cart items (from cart_id login), skip to step 11
                if (this.cartItems && this.cartItems.length > 0 && this.$route.params.cart_id) {
                    this.active_el = 11;

                    // Pre-populate medication from cart
                    const mainProduct = this.cartItems.find(item => !item.is_addon);
                    if (mainProduct) {
                        this.selectedMedication = mainProduct.name.toLowerCase();
                    }
                }
            }

            try {
                if (window.tracking) {
                    // Empty tracking event removed
                }
            } catch(error) {
                console.log(error)
            }
        },

        async handleCouponSubmit() {
            this.errorMessage = null;
            if (!this.paymentInfo.couponCode) {
                this.errorMessage = 'Please enter a coupon code';
                return;
            }
            await this.validateCoupon();
        },
        async validateCoupon() {
            if (this.couponApplied) return;
            this.couponError = false;
            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode,
                    payment_terms: this.paymentInfo.payment_terms
                });

                if (response.data.status === 'success') {
                    this.couponValid = true;
                    this.couponApplied = true;
                    this.paymentInfo.couponId = response.data.coupon_id;
                    if (response.data.c_type === 2) {
                        // Calculate percentage-based discount
                        const planAmount = this.getTotalOrderAmount();
                        const discountPercentage = response.data.c_val;
                        this.paymentInfo.discount = parseFloat(((planAmount * discountPercentage) / 100).toFixed(2));
                    } else {
                        this.paymentInfo.discount = response.data.c_val;
                    }

                } else {
                    this.couponValid = false;
                    this.couponError = true;
                }
            } catch (error) {
                this.couponValid = false;
                this.couponError = true;
            }
        },

        GoBack() {
            if (this.active_el > 11) {
                this.active_el--;
            }
        },



        // Stripe initialization
        async initStripe() {
            stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
        },

        prefillFromUserData() {
            const shipping = this.$store.getters.shipping;
            if (shipping) {
                if (!this.customerInfo.addressLine1 && shipping.address_line_1) this.customerInfo.addressLine1 = shipping.address_line_1;
                if (!this.customerInfo.addressLine2 && shipping.address_line_2) this.customerInfo.addressLine2 = shipping.address_line_2;
                if (!this.customerInfo.city && shipping.city) this.customerInfo.city = shipping.city;
                if (!this.customerInfo.state && shipping.state) this.customerInfo.state = shipping.state;
                if (!this.customerInfo.zip && shipping.zip) this.customerInfo.zip = shipping.zip;
            }
        },

        changePaymentTerms(value) {
            this.paymentInfo.payment_terms = value;
        },

        continueFromStep17() {
            this.active_el++;
        },

        async loadPlans() {
            try {
                const mainProduct = this.cartItems?.find(item => !item.is_addon);
                const productId = mainProduct?.id;
                if (!productId) return;
                const response = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`, {
                    params: { isPromo: true, productId }
                });
                if (response.data.status === 'success' && Array.isArray(response.data.plans)) {
                    const plans = {};
                    response.data.plans.forEach((plan) => {
                        if (plan && plan.terms != null && plan.price != null) {
                            plans[Number(plan.terms)] = { id: plan.id, price: Number(plan.price) };
                        }
                    });
                    this.apiPlans = plans;
                }
            } catch (error) {
                console.error('Error loading plans:', error);
            }
        },
        getProductPricing() {
            // Get medication from cart if not explicitly selected
            let medication = this.selectedMedication;
            if (!medication && this.cartItems && this.cartItems.length > 0) {
                const mainProduct = this.cartItems.find(item => !item.is_addon);
                if (mainProduct) {
                    medication = mainProduct.name.toLowerCase();
                }
            }
            // Default to semaglutide if still not set
            if (!medication) {
                medication = 'semaglutide';
            }

            const base = medication === 'semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;
            // Merge live plan prices over the env pricing so missing terms keep the fallback
            const pricing = { monthly: { ...base.monthly }, terms: { ...base.terms } };
            if (this.apiPlans[1]) {
                pricing.monthly = { first: this.apiPlans[1].price, regular: this.apiPlans[1].price };
            }
            [3, 6, 12].forEach((term) => {
                if (this.apiPlans[term]) {
                    pricing.terms[term] = this.apiPlans[term].price;
                }
            });
            return pricing;
        },

        getFirstMonthPrice() {
            const pricing = this.getProductPricing();
            return pricing?.monthly?.first || 0;
        },

        getRegularMonthlyPrice() {
            const pricing = this.getProductPricing();
            return pricing?.monthly?.regular || 0;
        },

        getTotalPrice(term) {
            const pricing = this.getProductPricing();
            const price = pricing?.terms?.[term];
            return price ? parseFloat(price.toFixed(2)) : 0;
        },

        formatDollars(amount) {
            return Math.floor(amount).toLocaleString('en-US');
        },

        formatPriceWithCommas(amount) {
            return Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },

        getCurrentPrice() {
            if (this.paymentInfo.payment_terms === 1) {
                return parseFloat(this.getFirstMonthPrice().toFixed(2));
            } else {
                return parseFloat(this.getTotalPrice(this.paymentInfo.payment_terms).toFixed(2));
            }
        },

        getTotalOrderAmount() {
            const basePrice = this.getCurrentPrice();
            const discount = this.paymentInfo.discount || 0;
            return Math.max(0, basePrice - discount);
        },

        getAddressData(address) {
            if (this.isPOBox(address.street)) {
                this.showError('Our shipping partners do not deliver to PO Box addresses.');
                return;
            }
            this.customerInfo.addressLine1 = address.street;
            this.customerInfo.addressLine2 = address.address_line2 || '';
            this.customerInfo.city = address.city;
            this.customerInfo.state = address.state;
            this.customerInfo.zip = address.zip;
        },

        isPOBox(address) {
            const normalized = address.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
            const poBoxRegex = /\b(po box|post office box|p o box)\b(?:\s*\d{0,6})?/i;
            return poBoxRegex.test(normalized);
        },

        validateAddress(address) {
            return address.addressLine1 &&
                address.city &&
                address.state &&
                address.zip;
        },

        blinkAddress() {
            this.addressBlink = true;
            setTimeout(() => { this.addressBlink = false; }, 1500);
        },

        async getStripeToken() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.paymentError = false;

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete shipping address.";
                this.blinkAddress();
                this.submitted = false;
                return false;
            }

            if (this.$refs.stripePayment) {
                await this.$refs.stripePayment.confirmPayment();
            }
        },

        handlePaymentError(message) {
            this.paymentError = true;
            this.errorMessage = message;
            this.submitted = false;
        },

        handlePaymentToken(pmToken) {
            this.paymentInfo.cardToken = pmToken;
            this.paymentInfo.paymentMethod = 'card';
            this.processPayment();
        },
        async handleExpressPayment(ev) {
            if (this.submitted) { ev.complete('fail'); return; } // a charge is already in flight
            try {
                this.submitted = true;
                this.correlationId = crypto.randomUUID();
                this.paymentError = false;
                this.paymentInfo.cardToken = ev.tokenId;
                this.paymentInfo.cardDetails = {
                    number: `XXXXXXXXXXXX${ev.card.last4}`,
                    expiration_month: ev.card.exp_month,
                    expiration_year: ev.card.exp_year,
                    cardBin: '',
                    cardBrand: ev.card.brand,
                    cardLast4: ev.card.last4,
                };
                this.paymentInfo.cardLast4 = ev.card.last4;
                this.paymentInfo.cardBrand = ev.card.brand;
                this.paymentInfo.paymentMethod = ev.methodName === 'apple-pay' ? 'apple_pay' : 'google_pay';
                if (ev.payerEmail && !this.paymentInfo.email) {
                    this.paymentInfo.email = ev.payerEmail;
                }
                await this.processPayment();
                ev.complete('success');
            } catch (error) {
                console.error('[Checkout] Express payment error:', error);
                ev.complete('fail');
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Payment failed. Please try again.';
                this.submitted = false;
            }
        },

        async payWithKlarna() {
            if (this.submitted) return; // prevent double-charge on rapid re-click / paint race
            this.submitted = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.paymentError = false;

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = 'Please enter a complete shipping address.';
                this.blinkAddress();
                this.submitted = false;
                return;
            }
            if (this.isPOBox(this.customerInfo.addressLine1)) {
                this.paymentError = true;
                this.errorMessage = 'Our shipping partners do not deliver to PO Box addresses.';
                this.submitted = false;
                return;
            }

            try {
                const billingAddr = this.customerInfo;
                const shippingAddress = {
                    addressLine1: this.customerInfo.addressLine1,
                    addressLine2: this.customerInfo.addressLine2,
                    city: this.customerInfo.city,
                    state: this.customerInfo.state,
                    zip: this.customerInfo.zip,
                };

                // amountInCents already nets out the coupon discount — don't subtract it again.
                const chargeAmount = this.amountInCents;

                const response = await this.$axios.post(`${this.baseUrl}/api/create-payment-intent`, {
                    id: this.user.id,
                    amount: chargeAmount,
                    payment_method_types: ['klarna'],
                    user_id: this.user.id,
                    planId: this.selectedPlanId,
                    payment_terms: this.paymentInfo.payment_terms,
                    couponId: this.paymentInfo.couponId,
                    discount: this.paymentInfo.discount,
                    firstName: this.user.first_name,
                    lastName: this.user.last_name,
                    email: this.user.email,
                    cartTotal: this.displayTotal,
                    shippingAddress,
                    billingAddress: {
                        addressLine1: billingAddr.addressLine1,
                        addressLine2: billingAddr.addressLine2,
                        city: billingAddr.city,
                        state: billingAddr.state,
                        zip: billingAddr.zip,
                    },
                    cartItems: this.cartItems,
                    mainProductTotal: this.getTotalOrderAmount(),
                    addonTotal: 0,
                    totalOrderAmount: this.displayTotal,
                    medication: this.selectedMedication || '',
                    drug_mode: this.paymentInfo.drug_mode || '',
                }, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });

                const { clientSecret } = response.data;
                const currentUrl = window.location.origin;
                const returnUrl = `${currentUrl}${this.$route.path}/klarna-return`;

                // Snapshot the cart BEFORE redirecting to Klarna so KlarnaReturn.vue — a fresh
                // page load after the redirect — can send cartItems on /api/confirm-klarna-payment
                // ([{ id: productObjectId, quantity, price }]). Keyed to this payment intent so a
                // stale snapshot never attaches to another checkout that shares KlarnaReturn.vue.
                // Mirrors checkoutCallCenter.vue.
                try {
                    const klarnaMainItem = (this.cartItems || []).find((i) => i && i.is_addon === false) || (this.cartItems || [])[0] || {};
                    const snapshotItems = [{
                        id: klarnaMainItem.id,
                        quantity: 1,
                        price: Number((chargeAmount / 100).toFixed(2)),
                    }];
                    sessionStorage.setItem('pending_klarna_cart', JSON.stringify({
                        payment_intent_id: clientSecret.split('_secret')[0],
                        items: snapshotItems,
                    }));
                } catch (e) { /* sessionStorage unavailable — confirm falls back to paymentIntentId only */ }

                // Same reason the cart is snapshotted: this page never runs again after
                // the redirect, so it can't fire its own `purchase`. KlarnaReturn.vue
                // fires this once the server confirms the payment.
                const klarnaMainProduct = this.cartItems.find(item => !item.is_addon);
                stashKlarnaPurchase(clientSecret.split('_secret')[0], {
                    funnel_step: 17,
                    event_value: Number((chargeAmount / 100).toFixed(2)),
                    product_id: klarnaMainProduct?.id,
                    product_name: klarnaMainProduct?.name,
                    plan_id: klarnaMainProduct?.stripe_id,
                    quantity: 1,
                    coupon: this.paymentInfo.couponCode || undefined,
                    form: "pre_qualify_v2"
                });

                // Klarna leaves the site, so KlarnaReturn.vue makes the offer instead.
                // Hand it the charge context before the redirect takes this page away.
                this.stashFastTrackOffer(clientSecret.split('_secret')[0], {
                    userId: this.user.id,
                    paymentMethod: 'klarna',
                    paymentTerms: this.paymentInfo.payment_terms,
                    firstName: this.user.first_name,
                    lastName: this.user.last_name,
                    email: this.user.email,
                    shippingAddress,
                    billingAddress: billingAddr,
                    trackingSessionId: window.trackingSessionId || null
                });

                const { error } = await stripe.confirmKlarnaPayment(clientSecret, {
                    payment_method: {
                        billing_details: {
                            name: `${this.user.first_name} ${this.user.last_name}`,
                            email: this.user.email,
                            address: {
                                line1: billingAddr.addressLine1,
                                line2: billingAddr.addressLine2 || '',
                                city: billingAddr.city,
                                state: billingAddr.state,
                                postal_code: billingAddr.zip,
                                country: 'US',
                            },
                        },
                    },
                    return_url: returnUrl,
                });

                if (error) {
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Klarna payment failed. Please try again.';
                    this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Failed to initiate Klarna payment. Please try again.';
                this.submitted = false;
            }
        },

        async processPayment() {
            try {
                this.submitted = true;
                this.paymentError = false;
                this.paymentInfo.user_id = this.user.id;
                this.paymentInfo.id = this.user.id;
                this.paymentInfo.medication = this.selectedMedication;
                this.paymentInfo.planId = this.selectedPlanId;

                // Get session ID - same robust pattern
                let sessionId = "";
                try {
                    sessionId = await window.tracking.assertSession();
                } catch(error) {
                    if (window.trackingSessionId) {
                        sessionId = window.trackingSessionId;
                    }
                }

                let paymentData = {
                    ...this.paymentInfo,
                    amount: this.amountInCents,
                    cartTotal: this.getTotalOrderAmount(),
                    cartTotalNoDiscount: parseFloat((this.getTotalOrderAmount() + (this.paymentInfo.discount || 0)).toFixed(2)),
                    billingAddress: this.customerInfo,
                    shippingAddress: this.customerInfo,
                    cartItems: this.cartItems,
                    totalOrderAmount: this.getTotalOrderAmount(),
                    user_agent: window.navigator.userAgent || 'unknown',
                    tracking_session_id: sessionId
                };

                // ===== COMMENTED OUT: Original endpoint =====
                // const response = await this.$axios.post(`${this.baseUrl}/api/checkout-newself`, paymentData);
                // ===== END COMMENTED OUT =====
                const response = await this.$axios.post(`${this.baseUrl}/api/checkout-stripe`, paymentData, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });
                // paymentData.amount already nets out the coupon discount — don't subtract it again
                let amountCharged = paymentData.amount / 100;

                if (response.data.status === 'success') {
                    // Save purchased products to localStorage
                    const purchasedItems = this.cartItems.map(item => ({
                        name: item.name,
                        price: amountCharged.toFixed(2)
                    }));
                    localStorage.setItem('productsPurchased', JSON.stringify(purchasedItems));

                    let transactionIdentifier;
                    try {
                        if (response.data.transaction_id) {
                            transactionIdentifier = response.data.transaction_id;
                        } else if (response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                            transactionIdentifier = response.data.prescriptionPreauths[0].transactionId;
                        } else {
                            transactionIdentifier = `${response.data.customerId}_${Date.now()}`;
                        }
                    } catch (e) {
                        console.log(e);
                        transactionIdentifier = `${Date.now()}`;
                    }

                    // Fire purchase tracking event after server-confirmed success
                    try {
                        if (window.tracking) {
                            const mainProduct = this.cartItems.find(item => !item.is_addon) || this.cartItems[0];
                            window.tracking.event('purchase', {
                                funnel_step: 17,
                                event_value: amountCharged,
                                currency: 'USD',
                                transaction_id: transactionIdentifier,
                                order_id: response.data.orderId,
                                event_id: crypto.randomUUID(),
                                product_id: mainProduct?.id,
                                product_name: mainProduct?.name,
                                plan_id: mainProduct?.stripe_id,
                                quantity: 1,
                                coupon: this.paymentInfo.couponCode || undefined,
                                form: "pre_qualify_v2"
                            });
                        }
                    } catch(error) {
                        // tracking errors are non-fatal
                    }

                    // Offer priority review on top of the confirmed order, then leave.
                    // With no add-on to offer this hands straight through to pushToRoute.
                    this.offerFastTrackThen({
                        userId: this.user.id,
                        paymentMethod: this.paymentInfo.paymentMethod || 'card',
                        paymentTerms: this.paymentInfo.payment_terms,
                        firstName: this.user.first_name,
                        lastName: this.user.last_name,
                        email: this.user.email,
                        shippingAddress: this.customerInfo,
                        billingAddress: this.customerInfo,
                        trackingSessionId: sessionId
                    }, () => this.pushToRoute(amountCharged, transactionIdentifier));
                } else {
                    this.errorMessage = response.data.message || "Payment failed";
                    this.submitted = false;
                    this.paymentError = true;
                     this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || "";
                this.submitted = false;
            }
        },

        pushToRoute(amountCharged, transaction_id) {
            try {
                const query = {};
                if (this.paymentInfo.payment_terms !== null) {
                    query.terms = String(this.paymentInfo.payment_terms);
                }
                query.amount = amountCharged;
                query.trans_id = transaction_id;
                this.$router.push({
                    name: 'prescriptionThanks',
                    query
                });
            } catch (error) {
                console.log(error);
                this.$router.push({
                    name: 'prescriptionThanks'
                });
            }
        }
    },

    watch: {
        paymentError(val) {
            if (val) {
                clearTimeout(this._errorTimeout);
                this._errorTimeout = setTimeout(() => { this.paymentError = false; }, 10000);
            }
        },
        active_el() {
            // Wait for DOM update, then scroll to top
            this.$nextTick(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
            });
        }
    }
}
</script>

<style scoped>

/* Price loading skeleton — hides env fallback price until live promo price loads */
.price-amt {
    display: inline-block;
}
.price-loading {
    color: transparent !important;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    min-width: 3ch;
}
.price-loading::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #e9e9e9 25%, #f5f5f5 50%, #e9e9e9 75%);
    background-size: 200% 100%;
    animation: price-shimmer 1.1s ease-in-out infinite;
}
@keyframes price-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

/* Order breakdown under the Due Today bar. Colours are inherited on purpose —
   these checkouts render on both the light and the dark shell. */
.ft-sum-breakdown {
    margin: 14px 0 22px;
}

.ft-sum-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    padding: 5px 0;
    font-size: 14px;
    line-height: 1.4;
}

.ft-sum-label {
    opacity: 0.75;
}

.ft-sum-value {
    display: inline-block;
    font-weight: 500;
    text-align: right;
    white-space: nowrap;
}

.ft-sum-total {
    margin-top: 8px;
    padding-top: 12px;
    border-top: 1px solid rgba(128, 128, 128, 0.35);
    font-size: 17px;
}

.ft-sum-total .ft-sum-label {
    opacity: 1;
    font-weight: 700;
}

.ft-sum-total .ft-sum-value {
    font-weight: 700;
}

@media screen and (max-width: 479px) {
    .ft-sum-row {
        font-size: 13px;
    }

    .ft-sum-total {
        font-size: 16px;
    }
}

/* Plan badges (Popular / Recommended) */
.plan-badge {
    position: absolute;
    top: -13px;
    left: 18px;
    z-index: 2;
    background-color: #d7fff0;
    color: #000;
    font-family: var(--satoshi, 'Satoshi', sans-serif);
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    padding: 6px 11px;
    border-radius: 999px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}


/* Plan card spacing/padding — bigger, more uniform */
.checkout_checkbox-field {
    padding: 20px 16px;
    margin-bottom: 14px;
}

.plans-div .checkout_checkbox-field:last-child {
    margin-bottom: 0;
}

/* Ensure the 12-month card has room for the inline savings badge */
.checkout_checkbox-field .div-block-2242 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
    /* lift price + Holiday Deal badge ~2px (works on desktop) */
    transform: translateY(-2px);
}

/* Mobile: pixel-based lift (breakpoint-independent) so the price + badge clearly move up */
@media screen and (max-width: 991px) {
    .checkout_checkbox-field .div-block-2242 {
        transform: translateY(-6px);
    }
}

.hideOnDesk {
    display: none;
}

.flow-step1-headers {
    margin-bottom: 15px;
}

.flow-inclusions-header {
    margin-bottom: 25px;
    justify-content: center;
    display: flex;
    line-height: 0px;
}

.continue-everything {
    margin-top: 25px;
}

.checkout_checkbox-selected {
    background-color: var(--light-blue);
}

.body_flow.page {
    min-height: 100vh !important;
    height: auto !important;
}

.field-error {
    border: 2px solid #dc3545 !important;
    border-color: #dc3545 !important;
}

input.field-error,
select.field-error {
    border: 2px solid #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.enroll-checkbox-field.field-error {
    border: 2px solid #dc3545;
    border-radius: 4px;
    padding: 8px;
    background-color: rgba(220, 53, 69, 0.05);
}

.link-block-30.field-error {
    border: 2px solid #dc3545 !important;
    background-color: rgba(220, 53, 69, 0.05) !important;
}

input.field-error:focus,
select.field-error:focus {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.w-input.field-error,
.w-select.field-error {
    border: 2px solid #dc3545 !important;
}

.loading-overlay2 {
    position: fixed;
    inset: 0;
    z-index: 99999;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.plan-radio {
    cursor: pointer;
    padding: 15px;
    border: 2px solid #ddd;
    border-radius: 8px;
    margin-bottom: 10px;
    transition: all 0.3s ease;
}

.plan-radio.selected {
    border-color: #00c042;
    background-color: #f0fff4;
}

.plan-radio:hover {
    border-color: #00c042;
}

@media screen and (max-width: 991px) {
    .section-fixed-prognav {
        position: relative !important;
        z-index: 99999 !important;
        background-color: white !important;
        /* ADJUST THIS VALUE to change spacing below header (0-50px) */
        margin-bottom: 30px !important;
        padding-bottom: 0 !important;
    }

    .section_checkout-flow {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .flow_wrap {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .glpquiz_div {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .quiz_herodiv {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
}

@media screen and (max-width: 375px) {

    .quiz_heroviddiv,
    .background-video-10 {
        height: 430px;
    }

    .flex-input-div.dob {
        margin-bottom: 1px;
    }

    .div-block-2251 {
        margin-top: 0px;
    }

    .text-block-1686 {
        font-size: 12px;
    }
}

@media screen and (max-width: 490px) {
    .div-block-2251 {
        margin-top: 5px;
    }

    .flow-inclusions-header {
        font-size: 26px;
    }
}

@media screen and (max-width: 479px) {
    .image-651 {
        width: 16px;
    }

    .error-popup {
        min-width: 90%;
    }
}

@media screen and (max-width: 375px) {
    .flow-inclusions-header[data-v-d0ce333a] {
        margin-top: 15px;
        line-height: 33px;
        font-size: 24px;
    }

    .enroll-header {
        flex-direction: column;
        align-items: left;
        padding-bottom: 5px;
        display: flex;
        margin-top: 7px;
        font-size: 32px;
    }

    .form-3-things-div {
        flex-flow: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 5px;
    }

    .formhero-sub {
        text-align: left;
        width: 100%;
        margin-bottom: 20px;
        font-size: 16px;
        line-height: 24px;
    }

    .formhero-sub[data-v-71c43630] {
        text-align: left;
        width: 100%;
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
        padding-top: 5px;
    }

    .product-name-2-copy {
        font-size: 16px;
    }

    .section-fixed-prognav[data-v-d0ce333a] {

        margin-bottom: 5px !important;
    }

    .enroll-checkbox-label.w-form-label {
        font-size: 9px;
    }
}

@media screen and (max-width: 350px) {
    .enroll-header {
        font-size: 30px;
    }

}

.checkout-checkbox-text {
    font-size: 16px;
}

/* Fix dropdown overflow issue on step 18 */
.flow-payment-div {
    overflow: visible !important;
}

.flow_step3-form-div {
    overflow: visible !important;
}

.checkout-form {
    overflow: visible !important;
}

.flow-dropdown-sum {
    overflow: visible !important;
    position: relative;
}

.dropdown-list-18 {
    position: relative !important;
    z-index: 1000;
}

.flow-payment-div.dropdown-expanded {
    padding-bottom: 450px;
}

.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: transparent;

}

.intro-modal-body {
    justify-content: center;
}

.intro-modal-heading {
    font-size: 18px;
    display: flex;
    justify-content: center;
}

.modal-content {
    background-color: #fefefe;
    border-radius: 10px;
    max-width: 468px;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

/* Out of Stock Modal Styles */
.modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    z-index: 99999;
}

.out-of-stock-modal {
    background-color: #ffffff;
    border-radius: 12px;
    max-width: 500px;
    width: 90%;
    margin: 0 !important;
    padding: 40px 30px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border: none !important;
}

.out-of-stock-modal .intro-modal-body {
    padding: 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.out-of-stock-modal .intro-modal-heading {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    margin: 0;
}

.modal-close-button {
    background-color: #e9ff86;
    color: #000;
    border: none;
    border-radius: 8px;
    padding: 12px 40px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.modal-close-button:hover {
    background-color: #d4e76f;
    transform: translateY(-2px);
}

span.select-icon {
    position: absolute;
    top: 15px;
    left: 5px;
}

.selectwrap {
    position: relative;
}

.checkout-flow-input.thirds {
    padding-left: 30px;
}

.checkout-flow-dropdown {
    padding-left: 25px;
}

.selectwrap input#birth-month {
    width: 100%;
}

.checkout_checkbox-field:active {
    background-color: #ece6ff00;
    border-color: transparent;
}

.tosspan {
    position: absolute;
    font-size: 8px;
    bottom: -3px;
    color: gray;
}

/* Express Checkout */
.express-checkout-section {
    margin-bottom: 16px;
}

.express-checkout-box {
    background: white;
    border: 1px solid #d8dbe0;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* NOTE: Uses .pe-divider instead of .divider — webflow CSS defines .divider { width: 1px } which would turn this vertical. */
.pe-divider {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
    margin: 12px 0;
    border: none;
    background: transparent;
}

.pe-divider-line {
    flex: 1;
    height: 1px;
    min-width: 0;
    background: #d8dbe0;
}

.pe-divider span {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
}

.pe-label-7x {
    font-weight: 350 !important;
    color: #4a4a57 !important;
    font-size: 0.9rem !important;
    line-height: 1.15 !important;
    margin-bottom: 4px !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
}
@media screen and (max-width: 991px) {
    .pe-label-7x {
        font-size: 16px !important;
        color: #000 !important;
    }
}

.address-section {
    margin-bottom: 20px;
}

.address-highlight :deep(input) {
    animation: blink-red 0.5s ease 3;
}
@keyframes blink-red {
    0%, 100% { border-color: inherit; }
    50% { border-color: #dc2626; box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.3); }
}

.error-popup {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #fee2e2;
    border: 1px solid #ef4444;
    color: #991b1b;
    padding: 12px 24px;
    border-radius: 8px;
    z-index: 2147483647;
    max-width: 90%;
    text-align: center;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.error-popup-close {
    background: none;
    border: none;
    color: #991b1b;
    font-size: 20px;
    cursor: pointer;
    padding: 0 2px;
    line-height: 1;
    flex-shrink: 0;
}

.klarna-btn {
    width: 100%;
    background: #ffb3c7;
    color: #0b0b0b;
    border: none;
    border-radius: 4px;
    padding: 12px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
    font-family: inherit;
    height: 48px;
}

.klarna-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 179, 199, 0.5);
}

.klarna-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.klarna-btn-text {
    font-size: 16px;
    font-weight: 600;
}

.klarna-logo {
    height: 18px;
    width: auto;
}

@media screen and (max-width: 479px) {
    .express-checkout-box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        padding: 16px;
        align-items: stretch;
    }

    .klarna-btn {
        flex-direction: column;
        padding: 4px 6px;
        gap: 2px;
        height: 48px;
        margin-top: 0;
    }

    .klarna-btn:only-child,
    .express-checkout-box.single-option .klarna-btn {
        grid-column: 1 / -1;
    }

    .klarna-btn-text {
        font-size: 11px;
        white-space: nowrap;
    }

    .klarna-logo {
        height: 16px;
    }
}
</style>

<style scoped>
/* Remove hover/focus/active highlight only when NOT selected */
.checkout_checkbox-field:not(.checkout_checkbox-selected):hover,
.checkout_checkbox-field:not(.checkout_checkbox-selected):focus,
.checkout_checkbox-field:not(.checkout_checkbox-selected):active {
    background-color: var(--white) !important;
    border-color: var(--df-grey) !important;
}
</style>
